/* unplugin-vue-components disabled */import script from "./ProductTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductTable.vue?vue&type=script&setup=true&lang=ts"

import "./ProductTable.vue?vue&type=style&index=0&id=f7933eb2&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7933eb2"]])

export default __exports__